import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AssetCategory  {
    _originalTypeClassName = "zERP.BO.AssetCategory";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AssetCategory.translate = translateService;
}
this.Subcategories = [];
this.Id = null;
this.Name = null;
this.Code = null;
this.Description = null;
this.UnitOfMeasurement = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
Code:any;
Description:any;
UnitOfMeasurement:any;
Subcategories:any;
DepreciationRate:any;
static setSubcategories = ($this, items) => {
                if (items == null) items = [];
                if ($this.Subcategories == null) $this.Subcategories = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Subcategories.length > 0) {
                    Domain.AssetCategory.removeSubcategories($this, $this.Subcategories[0]);
                }

                Domain.AssetCategory.addManySubcategories($this, copyItems);
            }
static addManySubcategories = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.AssetCategory.addSubcategories($this, items[i]);
                }
            }
static addSubcategories = ($this, item) => {
                if ($this.Subcategories == null) $this.Subcategories = [];
                if (item == null || $this.Subcategories.indexOf(item) > -1) return;
                $this.Subcategories.push(item);
}
static addRangeSubcategories = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.AssetCategory.addSubcategories($this, item));
            }
static removeSubcategories = ($this, item) => {
                if ($this == null || $this.Subcategories == null || $this.Subcategories.indexOf(item) === -1) return;
                var _index = $this.Subcategories.indexOf(item);
                $this.Subcategories.splice(_index, 1);
}
static clearSubcategories = ($this) => { $this.Subcategories = null; }
static setDepreciationRate = ($this, value) => {
var oldValue = $this.DepreciationRate;
$this.DepreciationRate = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}